import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import AddressSearch from '../AddressSearch';
import Request from '../../utils/request';

const CHANGE_EVENT = 'change';

class VenueAddressSearch extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
        return `
            <div class="lta-venue-address-search u-mb-5">
				<div class="lta-venue-address-search-title">${titleMarkup}</div>
                <div class="lta-venue-address-search-wrapper">
				${this.renderInstructionLabel(rowData?.instructionText)}
				<div class="lta-address-search">
				<div class="lta-address-search--error u-hidden" role="alertdialog">
				   <div class="lta-snackbar lta-snackbar--alert has-icon">
					  <p class="lta-snackbar__label title title" aria-label="Unfortunately we cannot find an address" onclick="">Unfortunately we cannot find an address</p>
					  <ul>
						 <li class="u-hidden">
							<span class="">Please check the house number and postcode</span>
						 </li>
						 <li>
							<span class="">Enter your address manually via the text below</span>
						 </li>
					  </ul>
					  <button type="button" class="lta-btn lta-btn--sm lta-btn--inverse lta-btn--block u-ml-1 js-dismiss-error">
					  Close
					  </button>
					  <div class="lta-snackbar__icon">
						 <svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="alert" aria-hidden="true">
							<use xlink:href="/static/images/icons/lta-icons.svg#alert"></use>
						 </svg>
					  </div>
				   </div>
				</div>
				<div class="lta-address-search--find" aria-live="polite" id="address-search">
				   <div class="lta-address-search--find-suggest lta-address-toggle-view">
					  <form id="addressSuggest" class="u-mb-3" data-url="/api/address/search" novalidate="novalidate">
						 <fieldset>
							<div class="lta-text-input__wrapper u-mb-3">
								${this.renderLabel(rowData?.label)}
							   <label for="houseNumber" class="lta-text-input__label">
							   ${rowData?.AddressLabel ? `${rowData.AddressLabel}` : 'Venue name or House No.'}
							   </label>
							   <div class="lta-text-input--error">
								  <div class="fv-plugins-message-container"></div>
							   </div>
							   <input type="text" class="lta-text-input" id="houseNumber" placeholder="eg. 3 Harly Liddon Court" ${
										rowData?.addressValue?.addressLine1 ? `value="${rowData?.addressValue?.addressLine1}"` : ``
									}
							} name="houseNumber" aria-label="House No. and Street name" autocomplete="on">
							</div>
							<div class="lta-text-input__wrapper u-mb-3">
							   <label for="postcode" class="lta-text-input__label">
							   Postcode
							   </label>
							   <div class="lta-text-input--error">
								  <div class="fv-plugins-message-container"></div>
							   </div>
							   <input type="text" class="lta-text-input" id="postcode" placeholder="eg. OX14 1AD" ${
										rowData?.addressValue?.postcode ? `value=${rowData?.addressValue?.postcode}` : ``
									}
									} name="postcode" aria-label="Postcode" autocomplete="on">
							</div>
						 </fieldset>
						 <button type="submit" form="addressSuggest" class="lta-btn lta-btn--default lta-btn--line lta-btn--block js-auto-submit">
						 Find address
						 </button>
						 <input type="hidden">
						 <div></div>
					  </form>
					  <p class="lta-address-search--toggle">enter address <a href="#" class="js-address-toggle" aria-controls="address-search" aria-label="enter address manually">manually</a></p>
				   </div>
				   <div class="lta-address-search--find-manual lta-address-toggle-view u-hidden">
					  <form id="addressManual" class="u-mb-3" novalidate="novalidate">
						 <fieldset>
							<div class="lta-text-input__wrapper u-mb-3">
							   <label for="manualStreet" class="lta-text-input__label">
							   		${rowData?.manualAddressLabel ? `${rowData.manualAddressLabel}` : `Venue name or House No. and Street`}
							   </label>
							   <div class="lta-text-input--error">
								  <div class="fv-plugins-message-container"></div>
							   </div>
							   <input type="text" class="lta-text-input" id="manualStreet" placeholder="" ${
										rowData?.addressValue?.addressLine1 ? `value=${rowData?.addressValue?.addressLine1}` : ``
									} name="street" aria-label="House No. and Street name" autocomplete="on">
							</div>
							<div class="lta-text-input__wrapper u-mb-3">
							   <label for="manualCity" class="lta-text-input__label">
							   Town/City
							   </label>
							   <div class="lta-text-input--error">
								  <div class="fv-plugins-message-container"></div>
							   </div>
							   <input type="text" class="lta-text-input" id="manualCity" placeholder="" ${
										rowData?.addressValue?.addressLine2 ? `value=${rowData?.addressValue?.addressLine2}` : ``
									} name="city" aria-label="Town/City" autocomplete="on">
							</div>
							<div class="lta-text-input__wrapper u-mb-3">
							   <label for="addressState" class="lta-text-input__label">
							   County (Optional)
							   </label>
							   <div class="lta-text-input--error"></div>
							   <input type="text" class="lta-text-input" id="addressState" placeholder="" ${
										rowData?.addressValue?.town ? `value=${rowData?.addressValue?.town}` : ``
							} name="state" aria-label="County (Optional)" autocomplete="on">
							</div>
							<div class="lta-text-input__wrapper u-mb-3">
							   <label for="addressPostcode" class="lta-text-input__label">
							   Postcode
							   </label>
							   <div class="lta-text-input--error">
								  <div class="fv-plugins-message-container"></div>
							   </div>
							   <input type="text" class="lta-text-input" id="addressPostcode" placeholder="" ${
										rowData?.addressValue?.postcode ? `value=${rowData?.addressValue?.postcode}` : ``
									} name="postCode" aria-label="Postcode" autocomplete="on">
							</div>
						 </fieldset>
						 <button type="submit" class="lta-btn lta-btn--default lta-btn--line lta-btn--block js-manual-submit" aria-controls="address-search-results">
						 Add address
						 </button>
						 <input type="hidden">
						 <div></div>
					  </form>
					  <p class="lta-address-search--toggle">Or use <a href="#" class="js-address-toggle" aria-controls="address-search" aria-label="enter address using auto-suggest">auto-suggest</a></p>
				   </div>
				</div>
				<div id="address-search-results" aria-live="polite">
				   <div class="lta-address-search--result u-hidden">
					  <p class="lta-text-input__label"></p>
					  <form class="js-add-venue-address">
						 <div class="lta-location-card u-mb-1">
							<div class="lta-location-card--content u-mb-1 md:u-mb-2"></div>
							<div class="lta-location-card--actions u-pt-2 u-hstack u-justify-space-between">
							   <button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-address-search--edit js-manual-edit">
								  <svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="pencil-fill" aria-hidden="true">
									 <use xlink:href="/static/images/icons/lta-icons.svg#pencil-fill"></use>
								  </svg>
								  Edit address
							   </button>
							   <button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-address-search--remove js-auto-edit">
								  <svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
									 <use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
								  </svg>
								  Search again
							   </button>
							</div>
						 </div>
					  </form>
				   </div>
				</div>
				<div class="lta-address-search--modal">
				   <div class="lta-modal" id="address-search-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
					  <div class="lta-modal-dialog">
						 <div class="lta-modal-top-angle">
							<svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
							   <polygon points="0,0 0,100 100,100" class="md:u-hidden"></polygon>
							   <polygon points="0,100 100,0 100,100" class="u-hidden md:u-block"></polygon>
							</svg>
						 </div>
						 <div class="lta-modal-content">
							<div class="lta-modal-header">
							   <p>We have found multiple addresses -</p>
							   <h2 class="u-title2">Please select one below:</h2>
							</div>
							<div class="lta-modal-body">
							   <form id="address-suggest" data-url="/api/address/select" novalidate="novalidate">
								  <fieldset>
									 <div class="lta-select">
										<label for="autosuggestAddress" class="lta-select__label" id="lta-select-label-autosuggestAddress">Select your address</label>
										<div class="lta-text-input--error">
										   <div class="fv-plugins-message-container"></div>
										</div>
										<div class="js-lta-select lta-select__wrapper lta-select--pre">
										   <select name="moniker" id="autosuggestAddress">
											  <option value="" disabled="" selected="" hidden=""> - Choose -</option>
										   </select>
										   <div class="lta-select__box">
											  <div class="lta-select__selected" tabindex="0" role="combobox" aria-owns="lta-select-items-autosuggestAddress" aria-expanded="false" aria-haspopup="listbox" aria-labelledby="lta-select-label-autosuggestAddress">
												 <span></span>
												 <div class="lta-select__caret-down" aria-hidden="true">
													<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="caret-down-fill" aria-hidden="true">
													   <use xlink:href="/static/images/icons/lta-icons.svg#caret-down-fill"></use>
													</svg>
												 </div>
											  </div>
											  <div class="lta-select__items-wrapper lta-select__items-wrapper--hide" id="lta-select-items-autosuggestAddress" role="listbox"></div>
										   </div>
										</div>
									 </div>
									 <button type="submit" form="address-suggest" class="lta-btn lta-btn--default lta-btn--primary lta-btn--block js-select-address u-mb-2 u-mt-3">
									 Confirm
									 </button>
								  </fieldset>
								  <input type="hidden">
								  <div></div>
							   </form>
							   <button type="button" class="lta-btn lta-btn--default lta-btn--line lta-btn--block js-lookup-cancel" aria-controls="address-search-results">
							   Cancel
							   </button>
							</div>
						 </div>
						 <div class="lta-modal-bottom-angle">
							<svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
							   <polygon points="0,0 100,0 100,100"></polygon>
							</svg>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
				</div>
            </div>
        `;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	renderLabel(label) {
		return label ? `<label class="lta-text-input__label u-block u-pb-1 u-text-grey-lta">${label}</label>` : '';
	}

	afterRender() {
		this.venueAddressSearchElement = SelectorEngine.findOne('.lta-venue-address-search', this.containerEl);
		this.venueAddressSearchWrapper = SelectorEngine.findOne('.lta-venue-address-search-wrapper', this.venueAddressSearchElement);
		this.venueAddressSearch = SelectorEngine.findOne('.lta-address-search', this.venueAddressSearchWrapper);
		this.initAddressSearch();
	}
	initAddressSearch() {
		this.addressSearchComponent = AddressSearch.getOrCreateInstance(this.venueAddressSearch);
		this.venueResult = SelectorEngine.findOne('#address-search-results', this.venueAddressSearch);
		this.venueAddressForm = SelectorEngine.findOne('.js-add-venue-address', this.venueResult);
		if(this.data?.addressValue) {
			this.addressSearchComponent.populateManualForm(this.data?.addressValue);
		}
		EventHandler.on(this.venueAddressForm, CHANGE_EVENT, (event) => {
			const address = event?.detail?.values;
			if (address) {
				this.setupValueObject(address, "Complete")
			}
			if(this.data?.saveAddress) {
				this.saveAddress();
			}
		});
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value ? {
				...value,
				onboardingStatus: obBoardingStatus
			} : undefined
		}

		if(this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	async saveAddress() {
		const formData = Object.fromEntries(new FormData(this.venueAddressForm).entries());
		try {
			await Request.post('/api/account/personal', {
				address: formData
			});
			
		} catch (error) {
			console.log(error);
		}
	}
	validate() {
		const validData = this.addressSearchComponent.validate();
		let isValid = false;
		if(validData === 'Valid') {
			isValid = true;
		}
		return isValid;
	}
}
export default VenueAddressSearch;
